import id from './id-ID.json';
import en from './en-EN.json';

export default { id, en };
